import Vue from "vue";
import "@/assets/js/quasar";
import store from "@/store";
import i18n from "@/i18n";
import vuelidate from "vuelidate";
import { $http, isValidBrowser, isValidPlatform } from "@/assets/js/appFunc";
import NotifyToast from "@/plugins/NotifyToast";
import DeniedApp from "@/pages/denied/app.vue";
import App from "./app.vue";
import router from "./router";
import CaptchaUtils from "../../plugins/CaptchaUtils";

Vue.use(vuelidate);
Vue.use(NotifyToast);

const browserValid = isValidPlatform() && isValidBrowser();

$http({ type: "GET", url: "/identity/auth/captchaKey" }, true)
    .then(({ data }) => {
        Vue.use(CaptchaUtils, { siteKey: data || null });
    })
    .catch(() => {
        Vue.use(CaptchaUtils, { siteKey: null });
    });

new Vue({
    router: browserValid ? router : undefined,
    store,
    i18n,
    el: "#app",
    created() {
        if (browserValid) {
            this.$toast.init(this);
            store().dispatch("main/checkValidTenant").then(() => {
                localStorage.removeItem("wrongTenantActive");
                store().dispatch("main/actMaintenanceActive").then(rsp => {
                    if (rsp.data.inProgress) {
                        localStorage.setItem("maintenanceStarted", rsp.data.inProgress);
                        localStorage.removeItem("maintenanceMessage");
                        localStorage.removeItem("maintenanceSchedule");
                        if (this.$route.name === "login" && this.$route.fullPath === "/maintenance/login") {
                            this.$root.$emit("maintenanceLogin");
                        } else if (this.$route.fullPath !== "/maintenance") {
                            this.$router.push("/maintenance");
                        }
                        if (rsp.data.redirectUrl && !window.location.href.includes("maintenance")) {
                            window.location.href = rsp.data.redirectUrl;
                        }
                    } else {
                        localStorage.removeItem("maintenanceStarted");
                        localStorage.removeItem("maintenanceUser");
                    }
                });
            }, (err) => {
                if (err.response.status === 404) {
                    this.$root.$emit("invalidTenantCheck");
                }
            });
        }
    },
    render: h => h(browserValid ? App : DeniedApp)
}).$mount();
